<template>
  <div id="chat-app">
    <div class="vs-row">
      <vs-col class="p-0" vs-xs="12" vs-sm="12" vs-lg="3" id="sidebar-div">
        <vs-sidebar class="items-no-padding" parent="#sidebar-div" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isChatSidebarActive" id="chat-list-sidebar">

        <div class="con-vs-card cardx chat-contact-list h-full mb-0">
          <div class="vs-card--content p-0">
            <vs-tabs>
              <vs-tab label="Chat">
                <div class="con-tab-ejemplo">
                      <VuePerfectScrollbar class="chat-scroll-area" :settings="settings" :key="$vs.rtl">
                  <ul class="chat-contacts">
                    <li
                      v-for="(chat, index) in chats"
                      :key="index"
                      @click="activeuser(index)"
                      class="flex justify-between py-5 cursor-pointer contact-item"
                    >
                      <div class="flex items-start px-3">
                        <img
                          :src="showuserimage(index)"
                          width="40"
                          class="rounded-full"
                          :alt="showusername(index)"
                        />
                        <div class="mx-3 py-1">
                          <b class="primary-color">{{ showusername(index) }}</b
                          ><br />
                          <span class="primary-color">{{
                            chatlastmsg(index).content
                          }}</span
                          ><br />
                          <small class="small body-color"
                            >{{ timeSince(chatlastmsg(index).time) }} ago</small
                          >
                        </div>
                      </div>
                    </li>
                  </ul>
                      </VuePerfectScrollbar>
                </div>
              </vs-tab>
              <vs-tab label="Contacts">
                <div class="con-tab-ejemplo">
                      <VuePerfectScrollbar class="chat-scroll-area" :settings="settings" :key="$vs.rtl">
                  <ul class="chat-contacts">
                    <li
                      v-for="item in contacts"
                      :key="item.index"
                      @click="activeuser(item.id)"
                      class="flex justify-between py-5 cursor-pointer contact-item"
                    >
                      <div class="flex items-start px-3">
                        <img
                          :src="item.pic"
                          width="40"
                          class="rounded-full"
                          :alt="item.title"
                        />
                        <div class="mx-3 py-1">
                          <b>{{ item.title }}</b
                          ><br />
                          <span>{{ item.position }}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                      </VuePerfectScrollbar>
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
        </vs-sidebar>
      </vs-col>
      <vs-col class="p-0" vs-xs="12" vs-sm="9"   vs-lg="6">
        <div
          class="con-vs-card cardx chat-user-profile mb-0 h-full rounded  lg:rounded-none border-r-0 border-l-0"
        >
          <div class="vs-card--content h-full p-0">
            <div class="chat-header flex align-middle text-left p-2">
              <a href="#" id="chat-menu" class="lg:hidden mr-3 cursor-pointer" @click="toggleChatSidebar(true)"><i class="icon-menu"></i></a>
              <img
                class="img-fluid mr-3 rounded-full"
                :src="showuserimage(activeChat)"
                width="54"
                alt=""
              />
              <div class="align-self-center mt-0 flex w-full">
                <div class="message-content">
                  <h6 class="mb-1 font-weight-bold d-flex">
                    {{ showusername(activeChat) }}
                  </h6>
                  typing ...
                  <br />
                </div>
                <div class="vs-spacer"></div>
                <div class="call-button ml-auto">
                  <a
                    href="#"
                    class="call h4 mt-2"
                    data-toggle="modal"
                    data-target="#call1"
                    ><i class="icon-phone"></i
                  ></a>
                  <a
                    href="#"
                    class="video-call h4 mt-2 ml-2"
                    data-toggle="modal"
                    data-target="#call1"
                    ><i class="icon-camrecorder"></i
                  ></a>
                </div>
              </div>
            </div>
            <div class="chat-window p-3">
              <VuePerfectScrollbar
                ref="chatwindow"
                class="scroll-area-chat-window"
                :settings="settings"
                @ps-scroll-y="scrollHandle"
              >
                <div id="component-chat-log" v-if="chatData" ref="chatLog">
                  <div
                    v-for="(msg, index) in chatData.msg"
                    class="msg-grp-container"
                    :key="index"
                  >
                    <template v-if="msg.sent">
                      <div class="flex mb-5">
                        <div class="speech-bubble p-3 ml-auto">
                          {{ msg.content }}
                        </div>
                        <vs-avatar
                          size="40px"
                          class="border-2 shadow border-solid border-white m-0 flex-shrink-0"
                          :class="msg.sent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
                          :src="userProfile.pic"
                        ></vs-avatar>
                      </div>
                    </template>
                    <template ref="chatLog" v-else>
                      <div class="flex mb-5">
                        <vs-avatar
                          size="40px"
                          class="border-2 shadow border-solid border-white m-0 flex-shrink-0"
                          :class="msg.sent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
                          :src="showuserimage(activeChat)"
                        ></vs-avatar>
                        <div class="speech-bubble alt p-3 mr-auto">
                          {{ msg.content }}
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </VuePerfectScrollbar>
            </div>
            <div class="chat-form">
              <div class="chat__input flex p-4">
                <vs-input
                  class="flex-1"
                  placeholder="Type Your Message"
                  v-model="typedMessage"
                />
                <vs-button
                  class="bg-primary-gradient ml-4"
                  type="filled"
                  @click="sendMsg"
                  ><i class="icon-cursor align-middle"></i
                ></vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col class="p-0" vs-xs="12" vs-lg="3">
        <div class="con-vs-card cardx chat-user-profile h-full">
          <div class="vs-card--content p-0">
            <div class="p-3">
              <h6>{{ userProfile.name }}</h6>
              <p>{{ userProfile.title }}</p>
            </div>
            <img
              :src="userProfile.pic"
              class="img-fluid"
              :alt="userProfile.title"
            />
            <div class="p-3 mb-0">
              <h6>Display Name</h6>
              <p>{{ userProfile.displayname }}</p>
            </div>
            <div class="p-3 mb-0">
              <h6>Local time</h6>
              <p>{{ userProfile.localtime }}</p>
            </div>
            <div class="p-3 mb-0">
              <h6>Email Address</h6>
              <p>{{ userProfile.emailaddress }}</p>
            </div>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  name: "app",
  components: {
    VuePerfectScrollbar,
  },
  data: function () {
    return {
       clickNotClose        : true,
      isChatSidebarActive  : true,
      activeChat: 1,
      typedMessage: "",
      settings: {
        maxScrollbarLength: 60,
      },
      userProfile: {
        name: "John Doe",
        pic: require("@/assets/images/team-3.jpg"),
        title: "Lead Web Developer - I can fix anything",
        displayname: "John",
        localtime: "3:40AM",
        emailaddress: "john@example.com",
      },
      chats: {
        1: {
          msg: [
            {
              content: "Hello John, how can I help you today ?",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: true,
              seen: true,
            },
            {
              content: "Hi, I want to buy a new shoes.",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: false,
              seen: true,
            },
            {
              content: "Shipment is free. You'll get your shoes tomorrow!",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: true,
              seen: true,
            },
            {
              content: "Wow that's great!",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: false,
              seen: true,
            },
            {
              content: "Ok. Thanks for the answer. Appreciated.",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: false,
              seen: true,
            },
            {
              content: "You are welcome!",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: true,
              seen: true,
            },
            {
              content: "Wow that's great!",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: false,
              seen: true,
            },
            {
              content: "Ok. Thanks for the answer. Appreciated.",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: false,
              seen: true,
            },
            {
              content: "You are welcome!",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: true,
              seen: true,
            },
          ],
        },
        2: {
          msg: [
            {
              content: "Hello John, how can I help you today ?",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: true,
              seen: true,
            },
            {
              content: "Hi, I want to buy a new shoes.",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: false,
              seen: true,
            },
          ],
        },
            3: {
          msg: [
            {
              content: "Hello John, how can I help you today ?",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: true,
              seen: true,
            },
            {
              content: "Hi, I want to buy a new shoes.",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: false,
              seen: true,
            },
          ],
        },
            4: {
          msg: [
            {
              content: "Hello John, how can I help you today ?",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: true,
              seen: true,
            },
            {
              content: "Hi, I want to buy a new shoes.",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: false,
              seen: true,
            },
          ],
        },
            5: {
          msg: [
            {
              content: "Hello John, how can I help you today ?",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: true,
              seen: true,
            },
            {
              content: "Hi, I want to buy a new shoes.",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: false,
              seen: true,
            },
          ],
        },
            6: {
          msg: [
            {
              content: "Hello John, how can I help you today ?",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: true,
              seen: true,
            },
            {
              content: "Hi, I want to buy a new shoes.",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: false,
              seen: true,
            },
          ],
        },
            7: {
          msg: [
            {
              content: "Hello John, how can I help you today ?",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: true,
              seen: true,
            },
            {
              content: "Hi, I want to buy a new shoes.",
              time: "Mon Dec 10 2018 07:45:00 GMT+0000 (GMT)",
              sent: false,
              seen: true,
            },
          ],
        },
      },
      contacts: [
        {
          id: 1,
          title: "Harry Jones",
          pic: require("@/assets/images/author2.jpg"),
          position: "Managing Partner at MDD",
          status: "online",
        },
        {
          id: 2,
          title: "Daniel Taylor",
          pic: require("@/assets/images/author3.jpg"),
          position: "Freelance Web Developer",
          status: "offline",
        },
        {
          id: 3,
          title: "Charlotte",
          pic: require("@/assets/images/author.jpg"),
          position: "Co-Founder &amp; CEO at Pi",
          status: "away",
        },
        {
          id: 4,
          title: "Jack Sparrow",
          pic: require("@/assets/images/author7.jpg"),
          position: "Managing Partner at MDD",
          status: "online",
        },
        {
          id: 5,
          title: "Bhaumik",
          pic: require("@/assets/images/author6.jpg"),
          position: "Managing Partner at MDD",
          status: "do not disturb",
        },
           {
          id: 6,
          title: "Charlotte",
          pic: require("@/assets/images/author.jpg"),
          position: "Co-Founder &amp; CEO at Pi",
          status: "away",
        },
        {
          id: 7,
          title: "Jack Sparrow",
          pic: require("@/assets/images/author7.jpg"),
          position: "Managing Partner at MDD",
          status: "online",
        },
        {
          id: 8,
          title: "Bhaumik",
          pic: require("@/assets/images/author6.jpg"),
          position: "Managing Partner at MDD",
          status: "do not disturb",
        },
           {
          id: 9,
          title: "Charlotte",
          pic: require("@/assets/images/author.jpg"),
          position: "Co-Founder &amp; CEO at Pi",
          status: "away",
        },
        {
          id: 10,
          title: "Jack Sparrow",
          pic: require("@/assets/images/author7.jpg"),
          position: "Managing Partner at MDD",
          status: "online",
        },
        {
          id: 11,
          title: "Bhaumik",
          pic: require("@/assets/images/author6.jpg"),
          position: "Managing Partner at MDD",
          status: "do not disturb",
        },
      ],
    };
  },
  computed: {
    chatData() {
      return this.chats[
        Object.keys(this.chats).find((key) => key == this.activeChat)
      ];
    },
      windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  watch: {
    windowWidth() {
      this.setSidebarWidth()
    }
  },
   created() {
  
    this.setSidebarWidth()
  },
  methods: {
    scrollHandle(evt) {
      console.log(evt);
    },
    showuserimage(uid) {
      const e = this.contacts.find((contact) => contact.id == uid);
      return e.pic;
    },
    showusername(uid) {
      const e = this.contacts.find((contact) => contact.id == uid);
      return e.title;
    },
    activeuser(uid) {
      this.activeChat = uid;
    },
    chatlastmsg(uid) {
      const msg = this.chats[uid].msg;
      const e = msg[msg.length - 1];
      return e;
    },
    timeSince(date) {
      date = new Date(date).getTime();
      var seconds = Math.floor((new Date() - date) / 1000);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return Math.floor(interval) + " years";
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return Math.floor(interval) + " months";
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return Math.floor(interval) + " days";
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return Math.floor(interval) + " hours";
      }
      interval = seconds / 60;
      if (interval > 1) {
        return Math.floor(interval) + " minutes";
      }
      return Math.floor(seconds) + " seconds";
    },
    sendMsg() {
      if (!this.typedMessage) return;
      const payload = {
        msg: {
          content: this.typedMessage,
          time: String(new Date()),
          sent: true,
          seen: false,
        },
        id: this.activeChat,
      };
      
      let chat = this.chats[
        Object.keys(this.chats).find((key) => key == this.activeChat)
      ];
      if (chat) {
        this.chats[
          Object.keys(this.chats).find((key) => key == this.activeChat)
        ].msg.push(payload.msg);
        this.$refs.chatwindow.$el.scrollTop = this.$refs.chatLog.scrollHeight + 60
      } else {
        this.chats[payload.id] = { msg: [payload.msg] };       
      } 
      this.typedMessage = "";
      this.activeChat=payload.id;     
      
    },
          setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = this.clickNotClose = false
      } else {
        this.isChatSidebarActive = this.clickNotClose = true
      }
    },
    toggleChatSidebar(value = false) {
      if (!value && this.clickNotClose) return
      this.isChatSidebarActive = value
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/styles/apps/chat.scss";
</style>